<template>
  <svg aria-hidden="true" width="15px" height="15px" data-v-777b7522=""><use xlink:href="#icon-twoyellow-red" data-v-777b7522=""></use></svg>
</template>

<script lang="ts">
export default {};
</script>
